import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RoleBasedRoute from './components/RoleBasedRoute';
import AdminLayout from './layouts/AdminLayout';
import AssociadoLayout from './layouts/AssociadoLayout';
import './css/global.css';
import GestorComercialLayout from './layouts/GestorComercialLayout';
import ComercialLayout from './layouts/ComercialLayout';
import DiretoriaComercialLayout from './layouts/DiretoriaComercialLayout';
import JuridicoLayout from './layouts/JuridicoLayout';
import GestorJuridicoLayout from './layouts/GestorJuridicoLayout';

// Import pages
import Home from './pages/Home/Home';
import Registration from './pages/Registration/Registration';
import Login from './pages/Login/Login';
import Unauthorized from './pages/Unauthorized/Unauthorized';
import Logos from './pages/Logos/Logos';
import InvistaConosco from './pages/InvistaConosco/InvistaConosco';
import QuemSomos from './pages/QuemSomos/QuemSomos';
import Precatorios from './pages/Precatorios/Precatorios';
import Servicos from './pages/Servicos/Servicos';
import Blog from './pages/Blog/Blog';
import Contato from './pages/Contato/Contato';

// Import Dashboards (without sidebar now)
import AdminDashboard from './pages/UsersArea/Admin/DashBoard/AdminDashboard';
import ComercialDashboard from './pages/UsersArea/Comercial/DashBoard/ComercialDashboard';
import ContabilDashboard from './pages/UsersArea/Contabil/DashBoard/ContabilDashboard';
import DiretoriaGeralDashboard from './pages/UsersArea/DiretoriaGeral/DashBoard/DiretoriaGeralDashboard';

import GestorComercialDashboard from './pages/UsersArea/GestorComercial/DashBoard/GestorComercialDashboard';
import DiretoriaComercialDashboard from './pages/UsersArea/DiretoriaComercial/DiretoriaComercialDashboard';

// Import Associado Pages
import AssociadoDashboard from './pages/UsersArea/Associado/Dashboard/AssociadoDashboard';
import AssociadoPrecatorioGroups from './pages/UsersArea/Associado/PrecatorioGroups';
import AssociadoPrecatorioGroupsBA from './pages/UsersArea/Associado/PrecatorioGroups/BA/PrecatorioGroupsBA';
import AssociadoPrecatorioGroupsMA from './pages/UsersArea/Associado/PrecatorioGroups/MA/PrecatorioGroupsMA';
import AssociadoPrecatorioGroupsRN from './pages/UsersArea/Associado/PrecatorioGroups/RN/PrecatorioGroupsRN';
import AssociadoPrecatorioGroupsPB from './pages/UsersArea/Associado/PrecatorioGroups/PB/PrecatorioGroupsPB';
import AssociadoPrecatorioGroupsRS from './pages/UsersArea/Associado/PrecatorioGroups/RS/PrecatorioGroupsRS';
import AssociadoPrecatorioGroupsPR from './pages/UsersArea/Associado/PrecatorioGroups/PR/PrecatorioGroupsPR';
import AssociadoPrecatorioGroupsSP from './pages/UsersArea/Associado/PrecatorioGroups/SP/PrecatorioGroupsSP';
import AssociadoPrecatorioGroupsRJ from './pages/UsersArea/Associado/PrecatorioGroups/RJ/PrecatorioGroupsRJ';
import AssociadoPrecatorioGroupsMG from './pages/UsersArea/Associado/PrecatorioGroups/MG/PrecatorioGroupsMG';
import AssociadoPrecatorioGroupsMT from './pages/UsersArea/Associado/PrecatorioGroups/MT/PrecatorioGroupsMT';
import AssociadoPrecatorioGroupsMS from './pages/UsersArea/Associado/PrecatorioGroups/MS/PrecatorioGroupsMS';

// Import Admin Pages
import AdminUsers from './pages/UsersArea/Admin/Users/AdminUsers';
import PrecatorioAssignment from './pages/UsersArea/Admin/PrecatorioAssignment/PrecatorioAssignment';
import TabelaRSL from './pages/UsersArea/Admin/TabelaRSL';
import BADashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/BA';
import MADashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/MA';
import PBDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/PB/PBDashboard';
import EmailManagement from './pages/UsersArea/Admin/EmailManagement';
import EmailManagementBA from './pages/UsersArea/Admin/EmailManagement/BA/EmailManagementBA';
import EmailManagementRN from './pages/UsersArea/Admin/EmailManagement/RN/EmailManagementRN';
import EmailManagementPB from './pages/UsersArea/Admin/EmailManagement/PB/EmailManagementPB';
import EmailManagementRS from './pages/UsersArea/Admin/EmailManagement/RS/EmailManagementRS';
import EmailManagementPR from './pages/UsersArea/Admin/EmailManagement/PR/EmailManagementPR';
import EmailManagementSP from './pages/UsersArea/Admin/EmailManagement/SP/EmailManagementSP';
import EmailManagementRJ from './pages/UsersArea/Admin/EmailManagement/RJ/EmailManagementRJ';
import EmailManagementMG from './pages/UsersArea/Admin/EmailManagement/MG/EmailManagementMG';
import EmailManagementMT from './pages/UsersArea/Admin/EmailManagement/MT/EmailManagementMT';
import EmailManagementMS from './pages/UsersArea/Admin/EmailManagement/MS/EmailManagementMS';
import CampaignAnalytics from './pages/UsersArea/Admin/EmailManagement/Analytics/CampaignAnalytics';
import CampaignDetail from './pages/UsersArea/Admin/EmailManagement/Analytics/CampaignDetail';
import EmailTest from './pages/UsersArea/Admin/EmailTest/EmailTest';
import OABEmailImport from './pages/UsersArea/Admin/OABEmailImport';
import PrecatorioReports from './pages/UsersArea/Admin/Reports/PrecatorioReports';
import PrecatorioStatistics from './pages/UsersArea/Admin/PrecatorioStatistics/PrecatorioStatistics';
import PrecatorioGroups from './pages/UsersArea/Admin/PrecatorioGroups';
import PrecatorioGroupsBA from './pages/UsersArea/Admin/PrecatorioGroups/BA/PrecatorioGroupsBA';
import PrecatorioGroupsMA from './pages/UsersArea/Admin/PrecatorioGroups/MA/PrecatorioGroupsMA';
import PrecatorioGroupsRN from './pages/UsersArea/Admin/PrecatorioGroups/RN/PrecatorioGroupsRN';
import PrecatorioGroupsPB from './pages/UsersArea/Admin/PrecatorioGroups/PB/PrecatorioGroupsPB';
import PrecatorioGroupsRS from './pages/UsersArea/Admin/PrecatorioGroups/RS/PrecatorioGroupsRS';
import PrecatorioGroupsPR from './pages/UsersArea/Admin/PrecatorioGroups/PR/PrecatorioGroupsPR';
import PrecatorioGroupsSP from './pages/UsersArea/Admin/PrecatorioGroups/SP/PrecatorioGroupsSP';
import PrecatorioGroupsRJ from './pages/UsersArea/Admin/PrecatorioGroups/RJ/PrecatorioGroupsRJ';
import PrecatorioGroupsMG from './pages/UsersArea/Admin/PrecatorioGroups/MG/PrecatorioGroupsMG';
import PrecatorioGroupsMT from './pages/UsersArea/Admin/PrecatorioGroups/MT/PrecatorioGroupsMT';
import PrecatorioGroupsMS from './pages/UsersArea/Admin/PrecatorioGroups/MS/PrecatorioGroupsMS';
import ForwardingControlPanel from './pages/UsersArea/Admin/EmailForwarding/ForwardingControlPanel';
import TaxasValores from './pages/UsersArea/Admin/TaxasValores';

// Import Calculator
import Calculator from './pages/UsersArea/Calculator/Calculator';

// Import Gestor Comercial Pages
import ComercialDistribution from './pages/UsersArea/GestorComercial/ComercialDistribution/ComercialDistribution';
import MeusPrecatorios from './pages/UsersArea/GestorComercial/MeusPrecatorios/MeusPrecatorios';
import ContactedPrecatoriosListGestor from './pages/UsersArea/GestorComercial/MeusPrecatorios/ContactedPrecatoriosList';
import PrecatoriosDesignadosGestor from './pages/UsersArea/GestorComercial/PrecatoriosDesignados/PrecatoriosDesignados';
import GroupListByState from './pages/UsersArea/GestorComercial/PrecatoriosDesignados/GroupListByState';
import TeamOverview from './pages/UsersArea/GestorComercial/TeamManagement/TeamOverview';

// Import Comercial Pages
import MeusPrecatoriosComercial from './pages/UsersArea/Comercial/MeusPrecatorios/MeusPrecatorios';
import ContactedPrecatoriosList from './pages/UsersArea/Comercial/MeusPrecatorios/ContactedPrecatoriosList';
import PrecatoriosDesignados from './pages/UsersArea/Comercial/PrecatoriosDesignados/PrecatoriosDesignados';
import ComercialGroupListByState from './pages/UsersArea/Comercial/PrecatoriosDesignados/GroupListByState';

// Import Diretoria Comercial Pages
import TeamOverviewDiretoria from './pages/UsersArea/DiretoriaComercial/TeamManagement/TeamOverview';
import MeusPrecatoriosDiretoria from './pages/UsersArea/DiretoriaComercial/MeusPrecatorios/MeusPrecatorios';
import ContactedPrecatoriosListDiretoria from './pages/UsersArea/DiretoriaComercial/MeusPrecatorios/ContactedPrecatoriosList';

// Import Analise Risco Pages
import AnaliseRiscoComercial from './pages/UsersArea/Comercial/AnaliseRisco/AnaliseRisco';
import AnaliseRiscoGestor from './pages/UsersArea/GestorComercial/AnaliseRisco/AnaliseRisco';
import AnaliseRiscoDiretoria from './pages/UsersArea/DiretoriaComercial/AnaliseRisco/AnaliseRisco';

// Import Juridico Pages
import JuridicoDashboardPage from './pages/UsersArea/Juridico/Dashboard/JuridicoDashboard';
import PrecatoriosDisponiveisList from './pages/UsersArea/Juridico/PrecatoriosDisponiveis/PrecatoriosDisponiveisList';
import MeusPrecatoriosJuridico from './pages/UsersArea/Juridico/MeusPrecatorios/MeusPrecatoriosJuridico';

// Import Gestor Juridico Pages  
import GestorJuridicoDashboard from './pages/UsersArea/GestorJuridico/Dashboard/GestorJuridicoDashboard';
import EquipeJuridica from './pages/UsersArea/GestorJuridico/EquipeJuridica/TeamOverview';

// Import Diretoria Juridico Pages
import DiretoriaJuridicoLayout from './layouts/DiretoriaJuridicoLayout';
import DiretoriaJuridicoDashboard from './pages/UsersArea/DiretoriaJuridico/Dashboard/DiretoriaJuridicoDashboard';
import GestoresOverview from './pages/UsersArea/DiretoriaJuridico/Gestores/GestoresOverview';
import FullTeamOverview from './pages/UsersArea/DiretoriaJuridico/EquipeCompleta/FullTeamOverview';
import DepartmentReports from './pages/UsersArea/DiretoriaJuridico/Relatorios/DepartmentReports';

// Import Precatorios Bahia Pages
import PrecatoriosBA from './pages/UsersArea/Precatorios/BA/PrecatoriosBA';
import PrecatoriosSelecionadasBA from './pages/UsersArea/Precatorios/BA/subpages/PrecatoriosSelecionadas';
import PrecatoriosPendentesBA from './pages/UsersArea/Precatorios/BA/subpages/PrecatoriosPendentes';
import PrecatoriosAltoValor from './pages/UsersArea/Precatorios/BA/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import BuscarDadosJurisConsult from './pages/UsersArea/Precatorios/BA/subpages/BuscarDadosJurisConsult/index';

// Import Precatorios Maranhão Pages
import PrecatoriosMA from './pages/UsersArea/Precatorios/MA/PrecatoriosMA';
import PrecatoriosSelecionadasMA from './pages/UsersArea/Precatorios/MA/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultMA from './pages/UsersArea/Precatorios/MA/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorMA from './pages/UsersArea/Precatorios/MA/subpages/PrecatoriosAltoValor';
import PrecatoriosPendentesMA from './pages/UsersArea/Precatorios/MA/subpages/PrecatoriosPendentes';

// Import Precatorios Rio Grande do Norte Pages
import PrecatoriosRN from './pages/UsersArea/Precatorios/RN/PrecatoriosRN';
import PrecatoriosSelecionadasRN from './pages/UsersArea/Precatorios/RN/subpages/PrecatoriosSelecionadas';
import PrecatoriosPendentesRN from './pages/UsersArea/Precatorios/RN/subpages/PrecatoriosPendentes';
import PrecatoriosAltoValorRN from './pages/UsersArea/Precatorios/RN/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import BuscarDadosJurisConsultRN from './pages/UsersArea/Precatorios/RN/subpages/BuscarDadosJurisConsult/index';

// Import Precatorios Paraíba Pages
import PrecatoriosPB from './pages/UsersArea/Precatorios/PB/PrecatoriosPB';
import PrecatoriosSelecionadasPB from './pages/UsersArea/Precatorios/PB/subpages/PrecatoriosSelecionadas';
import PrecatoriosPendentesPB from './pages/UsersArea/Precatorios/PB/subpages/PrecatoriosPendentes';
import PrecatoriosAltoValorPB from './pages/UsersArea/Precatorios/PB/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import BuscarDadosJurisConsultPB from './pages/UsersArea/Precatorios/PB/subpages/BuscarDadosJurisConsult/index';

// Import Precatorios Rio Grande do Sul Pages
import PrecatoriosRS from './pages/UsersArea/Precatorios/RS/PrecatoriosRS';
import PrecatoriosSelecionadasRS from './pages/UsersArea/Precatorios/RS/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultRS from './pages/UsersArea/Precatorios/RS/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorRS from './pages/UsersArea/Precatorios/RS/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import PrecatoriosPendentesRS from './pages/UsersArea/Precatorios/RS/subpages/PrecatoriosPendentes';
import RSDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/RS/RSDashboard';

// Import Precatorios Paraná Pages
import PrecatoriosPR from './pages/UsersArea/Precatorios/PR/PrecatoriosPR';
import PrecatoriosSelecionadasPR from './pages/UsersArea/Precatorios/PR/subpages/PrecatoriosSelecionadas';
import PrecatoriosPendentesPR from './pages/UsersArea/Precatorios/PR/subpages/PrecatoriosPendentes';
import PrecatoriosAltoValorPR from './pages/UsersArea/Precatorios/PR/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import BuscarDadosJurisConsultPR from './pages/UsersArea/Precatorios/PR/subpages/BuscarDadosJurisConsult/index';

// Import Precatorios Rio de Janeiro Pages
import PrecatoriosRJ from './pages/UsersArea/Precatorios/RJ/PrecatoriosRJ';
import PrecatoriosSelecionadasRJ from './pages/UsersArea/Precatorios/RJ/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultRJ from './pages/UsersArea/Precatorios/RJ/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorRJ from './pages/UsersArea/Precatorios/RJ/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import PrecatoriosPendentesRJ from './pages/UsersArea/Precatorios/RJ/subpages/PrecatoriosPendentes';
import RJDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/RJ/RJDashboard';

// Import Precatorios São Paulo Pages
import PrecatoriosSP from './pages/UsersArea/Precatorios/SP/PrecatoriosSP';
import PrecatoriosSelecionadasSP from './pages/UsersArea/Precatorios/SP/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultSP from './pages/UsersArea/Precatorios/SP/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorSP from './pages/UsersArea/Precatorios/SP/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import PrecatoriosPendentesSP from './pages/UsersArea/Precatorios/SP/subpages/PrecatoriosPendentes';
import SPDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/SP/SPDashboard';

// Import Precatorios Acre Pages
import PrecatoriosAC from './pages/UsersArea/Precatorios/AC/PrecatoriosAC';
import ACDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/AC/ACDashboard';

// Import Precatorios Alagoas Pages
import PrecatoriosAL from './pages/UsersArea/Precatorios/AL/PrecatoriosAL';
import ALDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/AL/ALDashboard';

// Import Precatorios Amazonas Pages
import PrecatoriosAM from './pages/UsersArea/Precatorios/AM/PrecatoriosAM';
import PrecatoriosSelecionadasAM from './pages/UsersArea/Precatorios/AM/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultAM from './pages/UsersArea/Precatorios/AM/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorAM from './pages/UsersArea/Precatorios/AM/subpages/PrecatoriosAltoValor';
import PrecatoriosPendentesAM from './pages/UsersArea/Precatorios/AM/subpages/PrecatoriosPendentes';
import AMDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/AM/AMDashboard';

// Import Precatorios Mato Grosso Pages
import PrecatoriosMT from './pages/UsersArea/Precatorios/MT/PrecatoriosMT';
import PrecatoriosSelecionadasMT from './pages/UsersArea/Precatorios/MT/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultMT from './pages/UsersArea/Precatorios/MT/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorMT from './pages/UsersArea/Precatorios/MT/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import PrecatoriosPendentesMT from './pages/UsersArea/Precatorios/MT/subpages/PrecatoriosPendentes';

// Import Precatorios Mato Grosso do Sul Pages
import PrecatoriosMS from './pages/UsersArea/Precatorios/MS/PrecatoriosMS';
import PrecatoriosSelecionadasMS from './pages/UsersArea/Precatorios/MS/subpages/PrecatoriosSelecionadas';
import BuscarDadosJurisConsultMS from './pages/UsersArea/Precatorios/MS/subpages/BuscarDadosJurisConsult';
import PrecatoriosAltoValorMS from './pages/UsersArea/Precatorios/MS/subpages/PrecatoriosAltoValor/PrecatoriosAltoValor';
import PrecatoriosPendentesMS from './pages/UsersArea/Precatorios/MS/subpages/PrecatoriosPendentes';

// Import Precatorios Minas Gerais Pages
import PrecatoriosMG from './pages/UsersArea/Precatorios/MG/PrecatoriosMG';

import APDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/AP/APDashboard';
import CEDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/CE/CEDashboard';
import DFDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/DF/DFDashboard';
import ESDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/ES/ESDashboard';
import GODashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/GO/GODashboard';
import MGDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/MG/MGDashboard';
import MSDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/MS/MSDashboard';
import MTDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/MT/MTDashboard';
import PADashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/PA/PADashboard';
import PEDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/PE/PEDashboard';
import PIDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/PI/PIDashboard';
import PRDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/PR/PRDashboard';
import RNDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/RN/RNDashboard';
import RODashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/RO/RODashboard';
import RRDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/RR/RRDashboard';
import SCDashboard from './pages/UsersArea/Admin/TabelaRSL/StatesRSL/SC/SCDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/registro" element={<Registration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/precatorios" element={<Precatorios />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/invista-conosco" element={<InvistaConosco />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/logos" element={<Logos />} />
            
            {/* Admin Routes - with AdminLayout wrapper */}
            <Route element={<RoleBasedRoute allowedRoles={['admin']} />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/precatorio-assignment" element={<PrecatorioAssignment />} />
                <Route path="/admin/tabela-RCL" element={<TabelaRSL />} />
                <Route path="/admin/tabela-RCL/ba" element={<BADashboard />} />
                <Route path="/admin/tabela-RCL/ma" element={<MADashboard />} />
                <Route path="/admin/tabela-RCL/pb" element={<PBDashboard />} />
                <Route path="/admin/tabela-RCL/rs" element={<RSDashboard />} />
                <Route path="/admin/tabela-RCL/rj" element={<RJDashboard />} />
                <Route path="/admin/tabela-RCL/sp" element={<SPDashboard />} />
                <Route path="/admin/tabela-RCL/ac" element={<ACDashboard />} />
                <Route path="/admin/tabela-RCL/al" element={<ALDashboard />} />
                <Route path="/admin/tabela-RCL/am" element={<AMDashboard />} />
                <Route path="/admin/tabela-RCL/ap" element={<APDashboard />} />
                <Route path="/admin/tabela-RCL/ce" element={<CEDashboard />} />
                <Route path="/admin/tabela-RCL/df" element={<DFDashboard />} />
                <Route path="/admin/tabela-RCL/es" element={<ESDashboard />} />
                <Route path="/admin/tabela-RCL/go" element={<GODashboard />} />
                <Route path="/admin/tabela-RCL/mg" element={<MGDashboard />} />
                <Route path="/admin/tabela-RCL/ms" element={<MSDashboard />} />
                <Route path="/admin/tabela-RCL/mt" element={<MTDashboard />} />
                <Route path="/admin/tabela-RCL/pa" element={<PADashboard />} />
                <Route path="/admin/tabela-RCL/pe" element={<PEDashboard />} />
                <Route path="/admin/tabela-RCL/pi" element={<PIDashboard />} />
                <Route path="/admin/tabela-RCL/pr" element={<PRDashboard />} />
                <Route path="/admin/tabela-RCL/rn" element={<RNDashboard />} />
                <Route path="/admin/tabela-RCL/ro" element={<RODashboard />} />
                <Route path="/admin/tabela-RCL/rr" element={<RRDashboard />} />
                <Route path="/admin/tabela-RCL/sc" element={<SCDashboard />} />
                
                {/* Email Management Routes */}
                <Route path="/admin/email" element={<EmailManagement />} />
                <Route path="/admin/email/ba" element={<EmailManagementBA />} />
                <Route path="/admin/email/rn" element={<EmailManagementRN />} />
                <Route path="/admin/email/pb" element={<EmailManagementPB />} />
                <Route path="/admin/email/rs" element={<EmailManagementRS />} />
                <Route path="/admin/email/pr" element={<EmailManagementPR />} />
                <Route path="/admin/email/sp" element={<EmailManagementSP />} />
                <Route path="/admin/email/rj" element={<EmailManagementRJ />} />
                <Route path="/admin/email/mg" element={<EmailManagementMG />} />
                <Route path="/admin/email/mt" element={<EmailManagementMT />} />
                <Route path="/admin/email/ms" element={<EmailManagementMS />} />
                <Route path="/admin/email/analytics" element={<CampaignAnalytics />} />
                <Route path="/admin/email/analytics/campaign/:campaignId" element={<CampaignDetail />} />
                <Route path="/admin/email-test" element={<EmailTest />} />
                <Route path="/admin/oab-email-import" element={<OABEmailImport />} />
                <Route path="/admin/reports" element={<PrecatorioReports />} />
                <Route path="/admin/precatorio-statistics" element={<PrecatorioStatistics />} />
                <Route path="/admin/email-forwarding" element={<ForwardingControlPanel />} />
                <Route path="/admin/taxas-valores" element={<TaxasValores />} />
                <Route path="/admin/calculadora" element={<Calculator />} />

                {/* Precatorio Groups Routes */}
                <Route path="/admin/precatorio-groups" element={<PrecatorioGroups />} />
                <Route path="/admin/precatorio-groups/ba" element={<PrecatorioGroupsBA />} />
                <Route path="/admin/precatorio-groups/ma" element={<PrecatorioGroupsMA />} />
                <Route path="/admin/precatorio-groups/rn" element={<PrecatorioGroupsRN />} />
                <Route path="/admin/precatorio-groups/pb" element={<PrecatorioGroupsPB />} />
                <Route path="/admin/precatorio-groups/rs" element={<PrecatorioGroupsRS />} />
                <Route path="/admin/precatorio-groups/pr" element={<PrecatorioGroupsPR />} />
                <Route path="/admin/precatorio-groups/sp" element={<PrecatorioGroupsSP />} />
                <Route path="/admin/precatorio-groups/rj" element={<PrecatorioGroupsRJ />} />
                <Route path="/admin/precatorio-groups/mg" element={<PrecatorioGroupsMG />} />
                <Route path="/admin/precatorio-groups/mt" element={<PrecatorioGroupsMT />} />
                <Route path="/admin/precatorio-groups/ms" element={<PrecatorioGroupsMS />} />

                {/* Precatorios Bahia Routes */}}
                <Route path="/admin/precatorios/ba" element={<PrecatoriosBA />} />
                <Route path="/admin/precatorios/ba/selecionadas" element={<PrecatoriosSelecionadasBA />} />
                <Route path="/admin/precatorios/ba/pendentes" element={<PrecatoriosPendentesBA />} />
                <Route path="/admin/precatorios/ba/alto-valor" element={<PrecatoriosAltoValor />} />
                <Route path="/admin/precatorios/ba/sincronizar" element={<BuscarDadosJurisConsult />} />
                
                {/* Precatorios Maranhão Routes */}
                <Route path="/admin/precatorios/ma" element={<PrecatoriosMA />} />
                <Route path="/admin/precatorios/ma/selecionadas" element={<PrecatoriosSelecionadasMA />} />
                <Route path="/admin/precatorios/ma/alto-valor" element={<PrecatoriosAltoValorMA />} />
                <Route path="/admin/precatorios/ma/pendentes" element={<PrecatoriosPendentesMA />} />
                <Route path="/admin/precatorios/ma/sincronizar" element={<BuscarDadosJurisConsultMA />} />

                {/* Precatorios Rio Grande do Norte Routes */}
                <Route path="/admin/precatorios/rn" element={<PrecatoriosRN />} />
                <Route path="/admin/precatorios/rn/selecionadas" element={<PrecatoriosSelecionadasRN />} />
                <Route path="/admin/precatorios/rn/pendentes" element={<PrecatoriosPendentesRN />} />
                <Route path="/admin/precatorios/rn/alto-valor" element={<PrecatoriosAltoValorRN />} />
                <Route path="/admin/precatorios/rn/sincronizar" element={<BuscarDadosJurisConsultRN />} />

                {/* Precatorios Paraíba Routes */}
                <Route path="/admin/precatorios/pb" element={<PrecatoriosPB />} />
                <Route path="/admin/precatorios/pb/selecionadas" element={<PrecatoriosSelecionadasPB />} />
                <Route path="/admin/precatorios/pb/pendentes" element={<PrecatoriosPendentesPB />} />
                <Route path="/admin/precatorios/pb/alto-valor" element={<PrecatoriosAltoValorPB />} />
                <Route path="/admin/precatorios/pb/sincronizar" element={<BuscarDadosJurisConsultPB />} />

                {/* Precatorios Rio Grande do Sul Routes */}
                <Route path="/admin/precatorios/rs" element={<PrecatoriosRS />} />
                <Route path="/admin/precatorios/rs/selecionadas" element={<PrecatoriosSelecionadasRS />} />
                <Route path="/admin/precatorios/rs/alto-valor" element={<PrecatoriosAltoValorRS />} />
                <Route path="/admin/precatorios/rs/pendentes" element={<PrecatoriosPendentesRS />} />
                <Route path="/admin/precatorios/rs/sincronizar" element={<BuscarDadosJurisConsultRS />} />

                {/* Precatorios Paraná Routes */}
                <Route path="/admin/precatorios/pr" element={<PrecatoriosPR />} />
                <Route path="/admin/precatorios/pr/selecionadas" element={<PrecatoriosSelecionadasPR />} />
                <Route path="/admin/precatorios/pr/pendentes" element={<PrecatoriosPendentesPR />} />
                <Route path="/admin/precatorios/pr/alto-valor" element={<PrecatoriosAltoValorPR />} />
                <Route path="/admin/precatorios/pr/sincronizar" element={<BuscarDadosJurisConsultPR />} />

                {/* Precatorios Rio de Janeiro Routes */}
                <Route path="/admin/precatorios/rj" element={<PrecatoriosRJ />} />
                <Route path="/admin/precatorios/rj/selecionadas" element={<PrecatoriosSelecionadasRJ />} />
                <Route path="/admin/precatorios/rj/alto-valor" element={<PrecatoriosAltoValorRJ />} />
                <Route path="/admin/precatorios/rj/pendentes" element={<PrecatoriosPendentesRJ />} />
                <Route path="/admin/precatorios/rj/sincronizar" element={<BuscarDadosJurisConsultRJ />} />

                {/* Precatorios São Paulo Routes */}
                <Route path="/admin/precatorios/sp" element={<PrecatoriosSP />} />
                <Route path="/admin/precatorios/sp/selecionadas" element={<PrecatoriosSelecionadasSP />} />
                <Route path="/admin/precatorios/sp/alto-valor" element={<PrecatoriosAltoValorSP />} />
                <Route path="/admin/precatorios/sp/pendentes" element={<PrecatoriosPendentesSP />} />
                <Route path="/admin/precatorios/sp/sincronizar" element={<BuscarDadosJurisConsultSP />} />

                {/* Precatorios Acre Routes */}
                <Route path="/admin/precatorios/ac" element={<PrecatoriosAC />} />

                {/* Precatorios Alagoas Routes */}
                <Route path="/admin/precatorios/al" element={<PrecatoriosAL />} />

                {/* Precatorios Amazonas Routes */}
                <Route path="/admin/precatorios/am" element={<PrecatoriosAM />} />
                <Route path="/admin/precatorios/am/selecionadas" element={<PrecatoriosSelecionadasAM />} />
                <Route path="/admin/precatorios/am/alto-valor" element={<PrecatoriosAltoValorAM />} />
                <Route path="/admin/precatorios/am/pendentes" element={<PrecatoriosPendentesAM />} />
                <Route path="/admin/precatorios/am/sincronizar" element={<BuscarDadosJurisConsultAM />} />

                {/* Precatorios Mato Grosso Routes */}
                <Route path="/admin/precatorios/mt" element={<PrecatoriosMT />} />
                <Route path="/admin/precatorios/mt/selecionadas" element={<PrecatoriosSelecionadasMT />} />
                <Route path="/admin/precatorios/mt/alto-valor" element={<PrecatoriosAltoValorMT />} />
                <Route path="/admin/precatorios/mt/pendentes" element={<PrecatoriosPendentesMT />} />
                <Route path="/admin/precatorios/mt/sincronizar" element={<BuscarDadosJurisConsultMT />} />

                {/* Precatorios Mato Grosso do Sul Routes */}
                <Route path="/admin/precatorios/ms" element={<PrecatoriosMS />} />
                <Route path="/admin/precatorios/ms/selecionadas" element={<PrecatoriosSelecionadasMS />} />
                <Route path="/admin/precatorios/ms/alto-valor" element={<PrecatoriosAltoValorMS />} />
                <Route path="/admin/precatorios/ms/pendentes" element={<PrecatoriosPendentesMS />} />
                <Route path="/admin/precatorios/ms/sincronizar" element={<BuscarDadosJurisConsultMS />} />

                {/* Precatorios Minas Gerais Routes */}
                <Route path="/admin/precatorios/mg" element={<PrecatoriosMG />} />

                {/* Add more admin routes here without repeating allowedRoles or sidebar */}
              </Route>
            </Route>
               
            {/* Diretoria Geral Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['diretoria_geral']} />}>
              <Route path="/diretoria-geral/dashboard" element={<DiretoriaGeralDashboard />} />
              {/* Add more diretoria geral routes here without repeating allowedRoles */}
            </Route>

            {/* Diretoria Comercial Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['diretoria_comercial']} />}>
              <Route element={<DiretoriaComercialLayout />}>
                <Route path="/diretoria-comercial/dashboard" element={<DiretoriaComercialDashboard />} />
                <Route path="/diretoria-comercial/meus-precatorios" element={<MeusPrecatoriosDiretoria />} />
                <Route path="/diretoria-comercial/meus-precatorios/:state" element={<ContactedPrecatoriosListDiretoria />} />
                <Route path="/diretoria-comercial/equipe" element={<TeamOverviewDiretoria />} />
                <Route path="/diretoria-comercial/calculadora" element={<Calculator />} />
                <Route path="/diretoria-comercial/analise-risco" element={<AnaliseRiscoDiretoria />} />
                {/* Add more diretoria comercial routes here */}
              </Route>
            </Route>
            
            {/* Diretoria Juridica Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['diretoria_juridica']} />}>
              <Route element={<DiretoriaJuridicoLayout />}>
                <Route path="/diretoria-juridico/dashboard" element={<DiretoriaJuridicoDashboard />} />
                <Route path="/diretoria-juridico/gestores" element={<GestoresOverview />} />
                <Route path="/diretoria-juridico/equipe-completa" element={<FullTeamOverview />} />
                <Route path="/diretoria-juridico/precatorios-disponiveis" element={<PrecatoriosDisponiveisList />} />
                <Route path="/diretoria-juridico/meus-precatorios" element={<MeusPrecatoriosJuridico />} />
                <Route path="/diretoria-juridico/relatorios" element={<DepartmentReports />} />
              </Route>
            </Route>

            {/* Associado Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['associado']} />}>
              <Route element={<AssociadoLayout />}>
                <Route path="/associado/dashboard" element={<AssociadoDashboard />} />
                <Route path="/associado/precatorio-groups" element={<AssociadoPrecatorioGroups />} />
                <Route path="/associado/precatorio-groups/ba" element={<AssociadoPrecatorioGroupsBA />} />
                <Route path="/associado/precatorio-groups/ma" element={<AssociadoPrecatorioGroupsMA />} />
                <Route path="/associado/precatorio-groups/rn" element={<AssociadoPrecatorioGroupsRN />} />
                <Route path="/associado/precatorio-groups/pb" element={<AssociadoPrecatorioGroupsPB />} />
                <Route path="/associado/precatorio-groups/rs" element={<AssociadoPrecatorioGroupsRS />} />
                <Route path="/associado/precatorio-groups/pr" element={<AssociadoPrecatorioGroupsPR />} />
                <Route path="/associado/precatorio-groups/sp" element={<AssociadoPrecatorioGroupsSP />} />
                <Route path="/associado/precatorio-groups/rj" element={<AssociadoPrecatorioGroupsRJ />} />
                <Route path="/associado/precatorio-groups/mg" element={<AssociadoPrecatorioGroupsMG />} />
                <Route path="/associado/precatorio-groups/mt" element={<AssociadoPrecatorioGroupsMT />} />
                <Route path="/associado/precatorio-groups/ms" element={<AssociadoPrecatorioGroupsMS />} />
                {/* Add more associado routes here */}
              </Route>
            </Route>
                        
            {/* Gestor Comercial Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['gestor_comercial']} />}>
              <Route element={<GestorComercialLayout />}>
                <Route path="/gestor-comercial/dashboard" element={<GestorComercialDashboard />} />
                <Route path="/gestor-comercial/distribuir-precatorios" element={<ComercialDistribution />} />
                <Route path="/gestor-comercial/meus-precatorios" element={<MeusPrecatorios />} />
                <Route path="/gestor-comercial/meus-precatorios/:state" element={<ContactedPrecatoriosListGestor />} />
                <Route path="/gestor-comercial/precatorios-designados" element={<PrecatoriosDesignadosGestor />} />
                <Route path="/gestor-comercial/precatorios-designados/:estado" element={<GroupListByState />} />
                <Route path="/gestor-comercial/equipe" element={<TeamOverview />} />
                <Route path="/gestor-comercial/calculadora" element={<Calculator />} />
                <Route path="/gestor-comercial/analise-risco" element={<AnaliseRiscoGestor />} />
                {/* Add more gestor comercial routes here */}
              </Route>
            </Route>
            
            {/* Gestor Jurídico Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['gestor_juridico']} />}>
              <Route element={<GestorJuridicoLayout />}>
                <Route path="/gestor-juridico/dashboard" element={<GestorJuridicoDashboard />} />
                <Route path="/gestor-juridico/equipe" element={<EquipeJuridica />} />
                <Route path="/gestor-juridico/precatorios-disponiveis" element={<PrecatoriosDisponiveisList />} />
                <Route path="/gestor-juridico/meus-precatorios" element={<MeusPrecatoriosJuridico />} />
              </Route>
            </Route>

            {/* Comercial Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['comercial']} />}>
              <Route element={<ComercialLayout />}>
                <Route path="/comercial/dashboard" element={<ComercialDashboard />} />
                <Route path="/comercial/meus-precatorios" element={<MeusPrecatoriosComercial />} />
                <Route path="/comercial/meus-precatorios/:state" element={<ContactedPrecatoriosList />} />
                <Route path="/comercial/precatorios-designados" element={<PrecatoriosDesignados />} />
                <Route path="/comercial/precatorios-designados/:estado" element={<ComercialGroupListByState />} />
                <Route path="/comercial/calculadora" element={<Calculator />} />
                <Route path="/comercial/analise-risco" element={<AnaliseRiscoComercial />} />
                {/* Add more comercial routes here */}
              </Route>
            </Route>
            
            {/* Contabil Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['contabilidade']} />}>
              <Route path="/contabil/dashboard" element={<ContabilDashboard />} />
              {/* Add more contabil routes here without repeating allowedRoles */}
            </Route>
            
            {/* Juridico Routes */}
            <Route element={<RoleBasedRoute allowedRoles={['juridico', 'gestor_juridico', 'diretoria_juridica']} />}>
              <Route element={<JuridicoLayout />}>
                <Route path="/juridico/dashboard" element={<JuridicoDashboardPage />} />
                <Route path="/juridico/precatorios-disponiveis" element={<PrecatoriosDisponiveisList />} />
                <Route path="/juridico/meus-precatorios" element={<MeusPrecatoriosJuridico />} />
                {/* Add more juridico routes here */}
              </Route>
            </Route>

          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
